module.exports = (__webpack_require__(22))(112);